/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const f = (r, t, e) => (e.configurable = !0, e.enumerable = !0, Reflect.decorate && typeof t != "object" && Object.defineProperty(r, t, e), e);
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
function a(r, t) {
  return (e, u, i) => {
    const c = (l) => {
      var n, o;
      return (o = (n = l.renderRoot) == null ? void 0 : n.querySelector(r)) != null ? o : null;
    };
    return f(e, u, { get() {
      return c(this);
    } });
  };
}
export {
  f as a,
  a as i
};
